module.exports = __webpack_public_path__ + "static/media/mammo.fa96576a.svg";